export const StarSolidMobile = () => (
  <svg
    width="28"
    height="26"
    viewBox="0 0 28 26"
    fill="none"
    className="inline mx-px my-0 align-baseline"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.578 1.36036L9.33634 7.85201L2.0052 8.87701C0.708531 9.07224 0.209814 10.6341 1.15738 11.5615L6.39391 16.5889L5.14712 23.6663C4.94763 24.9353 6.34404 25.9115 7.49109 25.3258L14.0243 21.9579L20.5076 25.3258C21.6547 25.9115 23.0511 24.9353 22.8516 23.6663L21.6048 16.5889L26.8413 11.5615C27.7889 10.6341 27.2902 9.07224 25.9935 8.87701L18.7122 7.85201L15.4207 1.36036C14.8721 0.237747 13.1765 0.188938 12.578 1.36036Z"
      fill="#292B29"
    />
  </svg>
);
